var $c28c98d58ee9ff6f$exports = {};
$c28c98d58ee9ff6f$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " n\xE3o selecionado.");
  },
  "longPressToSelect": "Mantenha pressionado para entrar no modo de sele\xE7\xE3o.",
  "select": "Selecionar",
  "selectedAll": "Todos os itens selecionados.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Nenhum item selecionado",
      one: function one() {
        return "".concat(formatter.number(args.count), " item selecionado");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " itens selecionados");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " selecionado.");
  }
};
export { $c28c98d58ee9ff6f$exports as default };